import * as Yup from 'yup';


export interface GroupLoginDto {
    groupId: string,
    password: string
}

export const groupLoginInit: GroupLoginDto = { groupId: '', password: '' };

export const groupLoginValidationSchema = Yup.object().shape({
    password: Yup.string().required("Password required")
});
